module.exports = __webpack_public_path__ + "media/mypage/images/ajax-loader@2x-6d21a3b8b54f08c8302f2853aa85b799.gif";